import { Component, ElementRef, Injector, Type } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { animate, state, style, transition, trigger } from "@angular/animations";
import { BmarkFwdRiskBlotterComponent } from "app/bfx-bmark-summary/blotters/spot-risk/bmark-fwd-risk-blotter.component";
import { BmarkFwdRiskContextMenuService } from "app/bfx-bmark-summary/blotters/spot-risk/services/bmark-fwd-risk-context-menu.service";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  BenchmarkDataPrimaryLookupService,
  BfxBlotterOrdersContextMenuItem,
} from "shared/cubiq-services";
import { BfxBaseBlotterContextMenu } from "../../../bfx-base-blotter/bfx-base-blotter-contextmenu";
import { BmarkSummaryContainerComponent } from "../../bmark-summary-container.component";

/**
 * View component for Fwd risk blotter context menu - always emits with all rows
 */
@Component({
  selector: "bmark-fwd-risk-context-menu",
  templateUrl: "./html/bmark-fwd-risk-context-menu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BmarkFwdRiskContextMenuComponent extends BfxBaseBlotterContextMenu<CubiqTS.OrderDataImpl> {
  constructor(
    injector: Injector,
    protected benchmarkSummary: BmarkSummaryContainerComponent,
    benchmarkLookupService: BenchmarkDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, benchmarkLookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BmarkFwdRiskContextMenuService> {
    return BmarkFwdRiskContextMenuService;
  }

  public selectedMenuItem(item: BfxBlotterOrdersContextMenuItem, event: PointerEvent) {
    if (!(event !== null && typeof event === "object" && event.isPrimary)) return;

    if (this.isItemEnabled(item)) {
      const allRows = (this.currentLadderBlotter as BmarkFwdRiskBlotterComponent)?.getAllRows();
      let menuService: BmarkFwdRiskContextMenuService = this
        .menuService as BmarkFwdRiskContextMenuService;
      menuService.fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        null,
        allRows,
        item.state,
        null,
        null,
        event,
      );
      this.hideMenu();
    }
  }
}
